import { routeDefinitions, siteConfig, siteContent } from '../../content/siteContent.js'
import { getLocalizedPath } from '../../lib/routing.js'

export function Header({ locale, slug }) {
  const copy = siteContent[locale]

  return (
    <header className="site-header">
      <a className="brand-lockup" href={getLocalizedPath(locale, 'home')} aria-label={copy.brand}>
        <img src="/logo.svg" alt="" />
        <span>
          <strong>{siteConfig.brandNameEn}</strong>
          <em>{siteConfig.brandNameZh}</em>
        </span>
      </a>
      <nav className="site-nav" aria-label="Primary">
        {copy.nav.slice(1).map((item) => (
          <a key={item.key} href={getLocalizedPath(locale, item.key)} aria-current={slug === item.key ? 'page' : undefined}>
            {item.label}
          </a>
        ))}
      </nav>
      <div className="locale-switcher" aria-label="Language">
        {Object.keys(siteContent).map((targetLocale) => (
          <a
            key={targetLocale}
            href={getLocalizedPath(targetLocale, routeDefinitions.find((route) => route.key === slug)?.key ?? slug)}
            aria-current={targetLocale === locale ? 'true' : undefined}
          >
            {siteContent[targetLocale].localeSwitchLabel}
          </a>
        ))}
      </div>
    </header>
  )
}
